import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import ContentWrapper from "../../../template/Layout/ContentWrapper";

import Loader from "../../../Global/Loader";

import Axios from "axios";
import { Services } from "../Services";
import { isMovil } from "../../../utils/device";
import "./styles.scss";
import MultiSelectPaginate from "../../../Global/MultiSelect";
import { loadOptions, getFilterData } from "./loadOptions";
import { filter, forEach } from "lodash";
import { FullLoader } from "../components/Loader";
import Table from "../../Components/TableCustom";
import { Modal, Space, Button } from "antd";
import DataTable from "../../Components/DataTable";
import { Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { Search } from "semantic-ui-react";
import CardsTotals from "../components/CardTotals";
import { Divider } from "antd";
import { saveAs } from "file-saver";
import moment from "moment";
import { validatePermission } from "../../../Global/Permission/validatePermission";
import { moduleActions } from "../../../Global/Permission/constants";
import HorizontalTimeline from "../components/TimeLine";

/*=============================================
=            BoardExpo Component              =
=============================================*/

const { confirm } = Modal;
class BoardExpo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolId: props._rolId,
      customWidth: window.innerWidth,
      fullLoader: false,
      loadingTrends: false,
      value: [],
      viewDetails: false,
      pages: 1,
      search: "",
      loading: false,
      loadingDetails: false,
      dashboardConfigId: 1,
      filters: [
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Reserva/Booking",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Factura",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Destinatario",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "DO",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "País de destino",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Cliente",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Funcionario",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Aduana",
        },
      ],
      filtersClients: [
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Reserva/Booking",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Factura",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Destinatario",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "DO",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "País de destino",
        },
      ],
      columnsProcess: [
        // {
        //   Id: 1,
        //   Name: "Embarques con DIM anticipadas SIN aceptar",
        //   Total: 0,
        //   EnRiesgo: 0,
        //   TipoDias: "Días calendario",
        //   Desviados: 0,
        // },
        {
          label: "Nombre y orden botones",
          dataIndex: "Name",
          key: "Name",
          backgroundColor: "#D8D8D8",
          textColor: "#000",
          textAlign: "left",
          custom: (value) => {
            return (
              <span
                style={{
                  color: "#003F70",
                  fontWeight: "bold",
                  textAlign: "left",
                  textColor: "#000",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.handleClickDetails(value.Id, value.Name);
                }}
              >
                {value.Name}
              </span>
            );
          },
        },
        // {
        //   label: "Nombre y orden botones",
        //   key: "nombre",
        //   backgroundColor: "#D8D8D8",
        //   textColor: "#000",
        //   sizeColumn: "150px",
        //   textAlign: "left",
        // },
        {
          label: "Total",
          key: "Total",
          backgroundColor: "#D8D8D8",
          textColor: "#000",
          sizeColumn: "8px",
        },
        {
          label: "Desviados",
          key: "Desviados",
          backgroundColor: "#D51C29",
          textColor: "#000",
          sizeColumn: "8px",
        },
        {
          label: "En riesgo",
          key: "EnRiesgo",
          backgroundColor: "#FFFF1D",
          textColor: "#000",
          sizeColumn: "8px",
        },
      ],
      processData: [
        // {
        //   Id: 1,
        //   Name: "Embarques con DIM anticipadas SIN aceptar",
        //   Total: 0,
        //   EnRiesgo: 0,
        //   TipoDias: "Días calendario",
        //   Desviados: 0,
        // },
        {
          Name: "Embarques con DIM anticipadas SIN aceptar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Embarques como entrega directa llegados SIN levante",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO's con DIM aceptadas SIN autoadhesivo o pago",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Mercancia en deposito público SIN levante",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Operaciones de DTA",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      pendingData: [
        {
          Name: "Embarques SIN ETA",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Embarques SIN documentos de transporte",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Otros documentos soporte pendientes",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO's SIN entrega al transporte",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO´s SIN despacho",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
      ],
      billingData: [
        {
          Name: "Embarques sin anticipo",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Embarques por facturar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Proformas por autorizar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Estado cartera",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      documentsData: [
        {
          Name: "Vigencia de registros o anexos",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      ExpoDetailsTables: {
        19: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Modo transporte internacional",
            key: "modoDeTransporte",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha notificación embarque",
            key: "fechaNotificacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaDeSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País con acuerdo",
            key: "paisConAcuerdo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha documentos completos",
            key: "fechaDocumentosCompletos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSAE",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Planilla de traslado",
            key: "planillaTraslado",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Transportador local o nacional",
            key: "transportadorLocalNacional",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Transportador internacional / ACI",
            key: "transportadorInternacional",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de llegada vehículo",
            key: "fechaLlegadaVehiculo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima de ingreso",
            key: "fechaMaximaIngreso",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaIngreso"]}</span>,
              };
            },
          },
        ],
        20: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Modo transporte internacional",
            key: "modoDeTransporte",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha notificación embarque",
            key: "fechaNotificacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha recibo factura o proforma",
            key: "fechaReciboFacturaOProforma",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País con acuerdo",
            key: "paisConAcuerdo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha instrucción certiorigen",
            key: "fechaInstruccionCertificadoOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha recibo certiorigen",
            key: "fechaReciboCertificadoOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Transportador local o nacional",
            key: "transportadorLocalNacional",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Transportador internacional/ACI",
            key: "transportadorInternacional",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "ETD",
            key: "etd",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima documentos completos",
            key: "fechaMaximaDocumentosCompletos",

            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaDocumentosCompletos"]}</span>,
              };
            },
          },
        ],
        21: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha notificación embarque",
            key: "fechaNotificacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Modo transporte internacional",
            key: "modoDeTransporte",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País con acuerdo",
            key: "paisConAcuerdo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha instrucción certiorigen",
            key: "fechaInstruccionCertificadoOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha recibo certiorigen",
            key: "fechaReciboCertificadoOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha documentos completos",
            key: "fechaDocumentosCompletos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSAE",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Planilla de traslado",
            key: "planillaTraslado",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de llegada vehículo",
            key: "fechaLlegadaVehiculo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha aviso de ingreso zona primaria",
            key: "fechaAvisoLlegadaZonaPrimaria",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "ETD",
            key: "etd",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima AE",
            key: "fechaMaximaAE",

            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAE"]}</span>,
              };
            },
          },
        ],
        22: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha documentos completos",
            key: "fechaDocumentosCompletos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSAE",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Autorización de embarque",
            key: "autorizacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha aviso de ingreso zona primaria",
            key: "fechaAvisoLlegadaZonaPrimaria",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha autorización embarque",
            key: "fechaMaximaAutorizacion",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "ETD",
            key: "etd",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima cut off físico",
            key: "fechaMaximaCutOffFisico",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaCutOffFisico"]}</span>,
              };
            },
          },
        ],
        23: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha instrucción certiorigen",
            key: "fechaInstruccionCertOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha inspección DIAN",
            key: "fechaInspeccionDIAN",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha autorización de embarque",
            key: "fechaAutorizacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha inspección otras entidades",
            key: "fechaInspeccionOtrasEntidades",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha antinarcóticos",
            key: "fechaAntinarcoticos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha radicación en puerto",
            key: "fechaRadicadoEnPuerto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha cut off físico",
            key: "fechaCutOffFisico",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima (ETD)",
            key: "etd",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["etd"]}</span>,
              };
            },
          },
        ],
        28: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifesto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima DEX",
            key: "fechaMaximaDEX",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaDEX"]}</span>,
              };
            },
          },
        ],
        29: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifesto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha DEX",
            key: "fechaMaximaDEX",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Prórroga datos provisionales",
            key: "prorrogaDatosProvisionales",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha límite datos provisionales",
            key: "fechaLimiteDatosProvisionales",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaLimiteDatosProvisionales"]}</span>,
              };
            },
          },
        ],
        30: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifesto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha DEX",
            key: "fechaDEX",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Régimen",
            key: "regimen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Prórroga términos",
            key: "prorrogaTerminos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha límite temporal",
            key: "fechaLimiteTemporal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaLimiteTemporal"]}</span>,
              };
            },
          },
        ],
        31: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País con acuerdo",
            key: "paisConAcuerdo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Modo transporte",
            key: "modoTranporte",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha instrucción certiorigen",
            key: "fechaInstruccionCertOrigen",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "ETD",
            key: "etd",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifesto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha DEX",
            key: "fechaDEX",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima entrega certiorigen",
            key: "fechaMaximaEntregaCertOrigen",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaEntregaCertOrigen"]}</span>,
              };
            },
          },
        ],
        24: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha notificación embarque",
            key: "fechaNotificacionEmbarque",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha solicitud anticipo",
            key: "fechaSolicitudAnticipo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha documentos completos",
            key: "fechaDocumentosCompletos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Autorización de embarque",
            key: "autorizacionEmbarques",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha radicado en puerto",
            key: "fechaRadicadoEnPuerto",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha cut off físico",
            key: "fechaCutOffFisico",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "ETD",
            key: "etd",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima anticipo",
            key: "fechaMaximaAnticipo",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAnticipo"]}</span>,
              };
            },
          },
        ],
        25: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Modo transporte internacional",
            key: "aduanaSalidamodoTransportInternacional",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSae",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Autorización de embarque",
            key: "autorizacionEmbarques",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Valor anticipo",
            key: "valorAnticipo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Número proforma Roldan",
            key: "numeroProformaRoldan",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima facturación",
            key: "fechaMaximaFacturacion",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha manifiesto",
            key: "fechaManifestoCarga",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaManifestoCarga"]}</span>,
              };
            },
          },
        ],
        26: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/exports-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/exports-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioAlCliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Números de factura",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSae",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifestoCarga",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha proforma Roldan",
            key: "fechaProforma",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Número proforma Roldan",
            key: "numeroProformaRoldan",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Valor gastos terceros",
            key: "valorGastosTerceros",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Valor ingresos propios",
            key: "valorIngresosPropios",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Suma gastos e ingresos",
            key: "sumaGastosIngresos",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Valor anticipo",
            key: "valorAnticipo",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Días sin autorización",
            key: "diasSinAutorizacion",
            minWidth: 150,
            maxWidth: 170,
            className: "col-md-3 col-lg-2 col-sm-6",
          },
          {
            label: "Fecha máxima autorización",
            key: "fechaMaximaAutorizacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAutorizacion"]}</span>,
              };
            },
          },
        ],
        27: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Servicio al cliente",
            key: "servicioCliente",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.servicioCliente.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.servicioCliente}</span>
                ),
            }),
          },
          {
            label: "Booking/reserva",
            key: "bookingNavieraOReserva",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana de salida",
            key: "aduanaSalida",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Destinatario",
            key: "destinatario",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "País destino",
            key: "paisdestino",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha SAE",
            key: "fechaSAE",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de zarpe",
            key: "fechaZarpe",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de manifiesto",
            key: "fechaManifestoCarga",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura Roldan",
            key: "fechaFacturacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Número factura Roldan",
            key: "numeroProformaRoldan",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor gastos terceros",
            key: "valorGastosTerceros",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor ingresos propios",
            key: "valorIngresosPropios",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Suma gastos e ingresos",
            key: "sumaGastosIngresos",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor anticipo",
            key: "valorAnticipo",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Días transcurridos cartera",
            key: "diastranscurridoscartera",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima pago",
            key: "fechaMaximaPago",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaPago"]}</span>,
              };
            },
          },
        ],
        32: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha levante",
            key: "fechaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha despacho total",
            key: "fechaDespachoTotal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Anticipo recibido",
            key: "anticipoRecibido",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Factura",
            key: "factura",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura",
            key: "fechaFactura",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor gastos terceros",
            key: "valorGastosTerceros",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor ingresos propios",
            key: "valorIngresosPropios",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Días de cartera",
            key: "diasCartera",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima de pago",
            key: "fechaMaximaPago",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaPago"]}</span>,
              };
            },
          },
        ],
      },
      columnsTable: [],
      dataTable: [],
      totalCards: [],
      selectedFilters: {
        "Reserva/Booking": [],
        Factura: [],
        Destinatario: [],
        DO: [],
        "Pais de destino": [],
        Cliente: [],
        Funcionario: [],
        Aduana: [],
      },
      timeLineData: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidMount = async () => {
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
    await this.getHomeData();
    //await this.getFilterData();
    console.log("props", this.props);

    this.setState({
      isMovilDevice: isMovil(),
    });
  };

  handleResize = () => {
    this.setState({ customWidth: window.innerWidth });
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleChange(newValue) {
    this.setState({ value: newValue });
  }

  getTableDetails = async (id, name, page = 1, search = "") => {
    try {
      this.setState(
        {
          columnsTable: [],
          dataTable: [],
          titleModal: name,
          activePage: page,
          dashboardConfigId: id,
          loadingModal: true,
        },
        async () => {
          const columns = this.state.ExpoDetailsTables[id] ?? [];
          // const response = {
          //   data: [
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#D51C29",
          //     },
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#FFFF1D",
          //     },
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#83c93c",
          //     },
          //   ],
          // };
          const url = `${Services.TABLEROS.path}/api/v1/expo/dashboard/getDetails`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            appliedFilters: JSON.stringify(this.state.selectedFilters),
            page,
            dashboardConfigId: id,
            search,
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });
          this.setState(
            {
              columnsTable: columns,
              dataTable:
                response.data?.data?.spGetExportDashboardDetail?.data ?? [],
              pages: response.data?.data?.spGetExportDashboardDetail
                ?.totalRecords
                ? Math.ceil(
                    parseInt(
                      response.data?.data?.spGetExportDashboardDetail
                        ?.totalRecords,
                    ) / 10,
                  )
                : 1,
            },
            async () => {
              this.setState({ viewDetails: true, loadingModal: false });
            },
          );
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({
        viewDetails: false,
        loadingModal: false,
      });
    }
  };

  getTableDetailsAll = async (id, search = "") => {
    try {
      const url = `${Services.TABLEROS.path}/api/v1/expo/dashboard/getDetailsAll`;
      const auth = localStorage.getItem("token");
      let data = {
        customer: this.props.clients
          ? JSON.stringify(this.props.clients)
          : "[0]",
        appliedFilters: JSON.stringify(this.state.selectedFilters),
        dashboardConfigId: id,
        search,
      };
      const response = await Axios.post(url, data, {
        headers: {
          authorization: auth,
        },
      });
      return response.data?.data?.spGetExportDashboardDetail?.data;
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({
        viewDetails: false,
      });
    }
  };

  handleClickDetails = (text, name) => {
    if (this.state.loadingDetails) return; // Evita doble clic
    this.setState({ loadingDetails: true });
    this.getTableDetails(text, name).finally(() => {
      this.setState({ loadingDetails: false }); // Quita esto si quieres que quede bloqueado
    });
  };

  handleSearch = (name) => (event) =>
    this.setState({ [name]: event.target.value });
  setSearch = () => {
    let search = this.state.search;
    const { titleModal, dashboardConfigId } = this.state;
    this.getTableDetails(dashboardConfigId, titleModal, 1, search).finally(
      () => {
        this.setState({ loadingDetails: false });
      },
    );
  };

  getHomeData = async () => {
    try {
      this.setState(
        {
          totalCards: [],
          fullLoader: false,
          timeLineData: [],
        },
        async () => {
          const url = `${Services.TABLEROS.path}/api/v1/expo/dashboard/getTotal`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          // const response = {
          //   data: {
          //     totals: [
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landTracking@16x.svg",
          //         name: "Estado tránsito intern (aplica con ser. de tracking)",
          //         value: 15,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouse@16x.svg",
          //         name: "Llegado",
          //         value: 234,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseVisibility@16x.svg",
          //         name: "Insp. prev.  o sanitarias",
          //         value: 45,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_certificateCheck@16x.svg",
          //         name: "Aceptados",
          //         value: 189,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseSavings@16x.svg",
          //         name: "Para pago",
          //         value: 23,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseVisibility@16x.svg",
          //         name: "Insp.  DIAN",
          //         value: 166,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_scheduleImports@16x.svg",
          //         name: "Levante sin entrega trans.",
          //         value: 12,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_documentDownload@16x.svg",
          //         name: "Sin facturar",
          //         value: 34,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landFreight@16x.svg",
          //         name: "En tránsito NNAL o con sello RIS",
          //         value: 28,
          //       },
          //     ],
          //     dataTables: [
          //       {
          //         items: [
          //           {
          //             Id: 1,
          //             Name: "Embarques con DIM anticipadas SIN aceptar",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días calendario",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 2,
          //             Name: "Embarques como entrega directa llegados SIN levante",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 4,
          //             Name: "DO's con DIM aceptadas SIN autoadhesivo o pago",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 3,
          //             Name: "Mercancia en deposito público SIN levante",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días calendario",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 5,
          //             Name: "Operaciones de DTA",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //         ],
          //         groupName: "EN PROCESO DE ADUANA",
          //       },
          //     ],
          //   },
          // };
          const totalCards =
            response?.data?.data?.spGetExportDashboard?.totals.map((t) => {
              return (
                <CardsTotals
                  image={t.icon}
                  xl={3}
                  md={3}
                  total={t.value}
                  title={t.name}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bgg-gray-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={
                    "d-flex col-8 py-3 bgg-gray align-items-center justify-content-center rounded-right"
                  }
                />
              );
            });

          const table =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control antes de zarpe",
            );

          if (table) {
            this.setState({ processData: table.items });
          }

          const tablePending =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control después de zarpe",
            );

          if (tablePending) {
            this.setState({ pendingData: tablePending.items });
          }

          const tableBilling =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Anticipos, Facturación y Cartera",
            );

          if (tableBilling) {
            this.setState({ billingData: tableBilling.items });
          }

          const tableDocuments =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control documentos",
            );

          if (tableDocuments) {
            this.setState({ documentsData: tableDocuments.items });
          }

          const timeLineData =
            response?.data?.data?.spGetExportDashboard?.totals ?? [];

          this.setState({ totalCards: totalCards, timeLineData }, async () => {
            this.setState({ fullLoader: true });
          });
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({ fullLoader: true });
    }
  };

  getHomeDataFilter = async () => {
    try {
      this.setState(
        {
          totalCards: [],
          fullLoader: false,
          timeLineData: [],
        },
        async () => {
          const url = `${Services.TABLEROS.path}/api/v1/expo/dashboard/getTotalFilters`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            appliedFilters: JSON.stringify(this.state.selectedFilters),
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          const totalCards =
            response?.data?.data?.spGetExportDashboard?.totals.map((t) => {
              return (
                <CardsTotals
                  image={t.icon}
                  xl={3}
                  md={3}
                  total={t.value}
                  title={t.name}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bgg-gray-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={
                    "d-flex col-8 py-3 bgg-gray align-items-center justify-content-center rounded-right"
                  }
                />
              );
            });

          const table =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control antes de zarpe",
            );

          if (table) {
            this.setState({ processData: table.items });
          }

          const tablePending =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control después de zarpe",
            );

          if (tablePending) {
            this.setState({ pendingData: tablePending.items });
          }

          const tableBilling =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Anticipos, Facturación y Cartera",
            );

          if (tableBilling) {
            this.setState({ billingData: tableBilling.items });
          }

          const tableDocuments =
            response?.data?.data?.spGetExportDashboard?.dataTables?.find(
              (table) => table.groupName === "Control documentos",
            );

          if (tableDocuments) {
            this.setState({ documentsData: tableDocuments.items });
          }
          const timeLineData =
            response?.data?.data?.spGetExportDashboard?.totals ?? [];
          this.setState({ totalCards: totalCards, timeLineData }, async () => {
            this.setState({ fullLoader: true });
          });
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({ fullLoader: true });
    }
  };

  getFilterData = async (search, prevOptions) => {
    this.setState(
      {
        loadingTrends: !this.stateloadingTrends,
      },
      async () => {
        try {
          const dicSelect = {
            reservaBooking: "Reserva/Booking",
            factura: "Factura",
            destinatario: "Destinatario",
            do: "DO",
            paisdestino: "Pais de destino",
            cliente: "Cliente",
            funcionario: "Funcionario",
            aduana: "Aduana",
          };
          const url = `${Services.TABLEROS.path}/api/v1/expo/dashboard/getFilters`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            search,
            page: 1,
            filter: "pedido",
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          const dataFilters = response?.data?.data;

          return;
        } catch (error) {
          console.log("🚀 ~  ~ error:", error);
          this.setState({ fullLoader: true });
        }
      },
    );
  };

  setValueFilters = async (filter, data) => {
    let selectedFilters = this.state.selectedFilters;
    selectedFilters[filter] = [...data];
    this.setState({ selectedFilters }, async () => {
      await this.getHomeDataFilter();
    });
  };

  changePage = async (changePage) => {
    const { titleModal, dashboardConfigId, search } = this.state;
    this.getTableDetails(
      dashboardConfigId,
      titleModal,
      changePage,
      search,
    ).finally(() => {
      this.setState({ loadingDetails: false });
    });
  };

  // downloadExcel = async () => {
  //   this.setState({
  //     loading: true,
  //   });
  //   let dateNow = new Date();
  //   let titleDownload = `Facturacion${
  //     dateNow.getDate() +
  //     "" +
  //     (dateNow.getMonth() + 1) +
  //     "" +
  //     dateNow.getFullYear()
  //   }`;

  //   let {
  //     numberPageInvoice,
  //     limitInvoice,
  //     searchInvoice,
  //     clientesSelect,
  //     filters,
  //     search,
  //   } = this.state;

  //   let data = {
  //     client: clientesSelect,
  //     pag: numberPageInvoice,
  //     limit: limitInvoice,
  //     search: searchInvoice,
  //     allData: true,
  //     search: search,
  //   };

  //   axios
  //     .post(
  //       `${Services.Api_Costos.path}/invoicing/downloadgetdataall?${filters}`,
  //       data
  //     )
  //     .then((success) => {
  //       const fileName = titleDownload + ".xlsx";
  //       const linkSource = `data:application/xlsx;base64,${success.data.dataReport}`;
  //       saveAs(linkSource, fileName);
  //       this.setState({
  //         loading: false,
  //       });
  //     })
  //     .catch((error) => {
  //       // this.setState({ loading: false });
  //     });
  // };

  generateExcel = async () => {
    this.setState({ loading: true });
    if (!(this.state.dataTable.length > 0)) {
      this.setState({
        loading: false,
      });
      return;
    }
    let search = this.state.search;
    const { dashboardConfigId } = this.state;
    let keys = [];
    let headers = [];
    const columnsData = this.state.ExpoDetailsTables[dashboardConfigId];

    columnsData.forEach((data) => {
      keys.push(data.key);
      headers.push(data.label);
    });

    let alldata = await this.getTableDetailsAll(dashboardConfigId, search);
    const columColor = keys[keys.length - 1];
    const dataxls = {
      data: alldata,
      options: {
        keys,
        headers,
        image: {
          name: "roldan",
        },
        sheetName: `${this.state.titleModal}_${moment(new Date()).format(
          "YYYYMMDD",
        )}`,
        columnStyles: {
          [columColor]: {
            fromField: "hex",
          },
        },
      },
    };

    try {
      if (alldata.length !== 0) {
        const getXlsxFile = await Axios.post(
          `${Services.DOWNLOAD_FILES.path}/report/dynamic/xlsx`,
          dataxls,
        );
        const fileName = `${this.state.titleModal}_${moment(new Date()).format(
          "YYYYMMDD",
        )}.xlsx`;
        const linkSource =
          "data:application/xlsx;base64," + getXlsxFile.data.base64;
        saveAs(linkSource, fileName);
        this.setState({
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      console.log("🚀 ~ generateExcel= ~ error:", error);
      this.setState({
        loading: true,
      });
    }
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      fullLoader,
      filters,
      filtersClients,
      loadingTrends,
      processData,
      pendingData,
      billingData,
      documentsData,
      titleModal,
      columnsTable,
      dataTable,
      viewDetails,
      pages,
      search,
      loading,
      totalCards,
      activePage,
      rolId,
      timeLineData,
      loadingModal,
    } = this.state;
    return (
      <>
        {/* <Loader hidden={fullLoader}/> */}
        <>
          <Loader hidden={fullLoader} />
          <ContentWrapper>
            <div className="content-heading">
              <legend className="legendTitle">
                <img
                  // style={{ margin: "6px", marginTop: "-1px" }}
                  src="https://fsposeidon.blob.core.windows.net/roldan/icon_containerVisibility@16x.svg"
                  height="28"
                  width="28"
                ></img>
                Tablero aduana exportaciones
              </legend>
            </div>
            {loadingModal ? (
              <center>
                {" "}
                <Loader />
              </center>
            ) : (
              <Modal
                title={
                  <h4
                    style={{
                      fontSize: "20px",
                      padding: "0.5rem",
                      color: "#fff",
                    }}
                  >
                    {titleModal}
                  </h4>
                }
                centered
                open={viewDetails}
                footer={[]}
                onOk={() =>
                  this.setState({
                    viewDetails: false,
                    search: "",
                  })
                }
                onCancel={() =>
                  this.setState({
                    viewDetails: false,
                    search: "",
                  })
                }
                width={2000}
              >
                <div style={{ padding: "1.5rem" }}>
                  <div className="row">
                    <div className="col-xs-12 col-md-6 col-lg-6 row pb-3">
                      <div className="col-10">
                        <Search
                          input={{
                            icon: "search",
                            iconPosition: "left",
                            fluid: true,
                          }}
                          placeholder="..."
                          value={search}
                          open={false}
                          name="search"
                          id="search"
                          onSearchChange={this.handleSearch("search")}
                          onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                              this.setSearch();
                            }
                          }}
                        />
                      </div>
                      <div className="col-2 visible-xls-desktops">
                        {loading ? (
                          <center>
                            {" "}
                            <Icon
                              loading={loading}
                              style={{ marginTop: "3px", marginLeft: "-3em" }}
                              name="circle notch"
                              size="large"
                            />
                          </center>
                        ) : (
                          <center>
                            <em
                              style={{
                                color: "#43a047",
                                marginTop: "4px",
                                marginLeft: "-3em",
                              }}
                              onClick={this.generateExcel}
                              className="download fa-2x fas fa-file-excel"
                            ></em>
                          </center>
                        )}
                      </div>
                    </div>
                  </div>
                  <DataTable
                    data={dataTable}
                    columnsTable={columnsTable}
                    subTable={[]}
                    activePage={activePage}
                    numberPageInvoice={pages}
                    handlePaginationChange={this.changePage}
                  ></DataTable>
                </div>
              </Modal>
            )}
            {/* <Card> */}
            {validatePermission(rolId, moduleActions.TABLEROS_EXPO) ? (
              <div className="row">
                {filters.map((f) => {
                  return (
                    <div className={f.col}>
                      <MultiSelectPaginate
                        loadOptions={getFilterData}
                        title={f.title}
                        clients={
                          this.props.clients
                            ? JSON.stringify(this.props.clients)
                            : "[0]"
                        }
                        setValueFilters={this.setValueFilters}
                      />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="row">
                {filtersClients.map((f) => {
                  return (
                    <div className={f.col}>
                      <MultiSelectPaginate
                        loadOptions={getFilterData}
                        title={f.title}
                        clients={
                          this.props.clients
                            ? JSON.stringify(this.props.clients)
                            : "[0]"
                        }
                        setValueFilters={this.setValueFilters}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            <Divider />
            <Row>
              {/*totalCards.map((card) => {
                return card;
              })*/}

              {loadingTrends ? (
                <FullLoader />
              ) : (
                <HorizontalTimeline data={timeLineData} />
              )}
            </Row>
            <Divider />
            <Row>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      Control antes de zarpe{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={processData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      Control después de zarpe{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={pendingData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      Anticipos, Facturación y Cartera{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={billingData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              {/*validatePermission(rolId, moduleActions.TABLEROS_EXPO) ? (
                <Col xs={12} md={12} lg={6}>
                  <div className="card myCard equalsWidth">
                    <div className="card-header">
                      <div className="card-title-board">
                        {" "}
                        Control documentos{" "}
                      </div>
                    </div>
                    <div
                      style={{ fontWeight: 100, marginTop: "-2rem" }}
                      className="card-body"
                    >
                      {loadingTrends ? (
                        <FullLoader />
                      ) : (
                        <div>
                          <Table
                            data={documentsData}
                            columns={this.state.columnsProcess}
                            options={{
                              pagination: false,
                              search: false,
                              downloads: { xlsx: false, pdf: false },
                            }}
                          ></Table>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              ) : (
                ""
              )*/}
            </Row>
          </ContentWrapper>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BoardExpo);
